module.exports = __webpack_public_path__ + "img/model_100.70fb7078.jpg";